import React, { useEffect, createElement } from 'react';
import { TopBar } from './components/TopBar';
import { BrandHeader } from './components/BrandHeader';
import { Hero } from './components/Hero';
import { PorQueAmazon } from './components/PorQueAmazon';
import { Identification } from './components/Identification';
import { Solution } from './components/Solution';
import { Product } from './components/Product';
import { Bonuses } from './components/Bonuses';
import { ValueStack } from './components/ValueStack';
import { Benefits } from './components/Benefits';
import { Transition } from './components/Transition';
import { PremiumProduct } from './components/PremiumProduct';
import { PremiumBonuses } from './components/PremiumBonuses';
import { FinalCTA } from './components/FinalCTA';
import { MarcaPrivadaProduct } from './components/MarcaPrivadaProduct';
import { MarcaPrivadaIncluye } from './components/MarcaPrivadaIncluye';
import { MarcaPrivadaBonuses } from './components/MarcaPrivadaBonuses';
import { MarcaPrivadaTestimonials } from './components/MarcaPrivadaTestimonials';
import { SistemaCompleto } from './components/SistemaCompleto';
import { QueAprenderas } from './components/QueAprenderas';
import { Resultados } from './components/Resultados';
import { PreCTA } from './components/PreCTA';
import { PricingOptions } from './components/PricingOptions';
import { Objections } from './components/Objections';
import { Testimonials } from './components/Testimonials';
import { MarcaTestimonials } from './components/MarcaTestimonials';
import { SistemaTestimonials } from './components/SistemaTestimonials';
import { Urgency } from './components/Urgency';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1100702405600602');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // Noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1100702405600602&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.head.appendChild(noscript);
  }, []);
  return <div className="min-h-screen bg-brand-white font-sans text-brand-text selection:bg-brand-gold/30" data-id="element-0">
      <TopBar data-id="element-1" />
      <BrandHeader data-id="element-2" />
      <Hero data-id="element-3" />
      <PorQueAmazon data-id="element-4" />
      <Identification data-id="element-5" />
      <Solution data-id="element-6" />
      <Product data-id="element-7" />
      <Bonuses data-id="element-8" />
      <ValueStack data-id="element-9" />
      <Benefits data-id="element-10" />
      <SistemaCompleto data-id="element-11" />
      <QueAprenderas data-id="element-12" />
      <Resultados data-id="element-13" />
      <Transition data-id="element-14" />
      <PremiumProduct data-id="element-15" />
      <PremiumBonuses data-id="element-16" />
      <FinalCTA data-id="element-17" />
      <MarcaPrivadaProduct data-id="element-18" />
      <MarcaPrivadaIncluye data-id="element-19" />
      <MarcaPrivadaBonuses data-id="element-20" />
      <MarcaPrivadaTestimonials data-id="element-21" />
      <PricingOptions data-id="element-22" />
      <Objections data-id="element-23" />
      <Testimonials data-id="element-24" />
      <MarcaTestimonials data-id="element-25" />
      <SistemaTestimonials data-id="element-26" />
      <PreCTA data-id="element-27" />
      <Urgency data-id="element-28" />
      <Footer data-id="element-29" />
    </div>;
}